import common from '../language/th/common.json';
import login from '../language/th/login.json';
import search from '../language/th/search.json';

import button from '../language/th/button.json';
import home from '../language/th/home.json';
import menu from '../language/th/menu.json';
import share from '../language/th/share.json';
import user from '../language/th/user.json';
import master from '../language/th/master.json';
import systemInfo from './th/systemInfo.json';
import tracker from './th/tracker.json';
import settings from './th/settings.json';
import training from './th/training.json';
import car from './th/car.json';
import driverJob from './th/driverJob.json';
import settingsCarReservation from './th/settingsCarReservation.json';
import project from './th/project.json';

export default {
    ...common,
    ...login,
    ...search,
    ...button,
    ...home,
    ...menu,
    ...share,
    ...user,
    ...master,
    ...systemInfo,
    ...tracker,
    ...settings,
    ...training,
    ...car,
    ...driverJob,
    ...settingsCarReservation,
    ...project
};



// WEBPACK FOOTER //
// ./src/wording/language/th.js